export class ThemeModal{
	init() {
		var self = this;
		$(document).on('click', '#themesModal .features-list__header.performances, #themesModal .themes-list__price-bullet', function(e) {
			e.preventDefault();

            if(this.classList.contains('extend-theme')){
                setTimeout(function(){
                    self.expandAcordionWithChart();
                }, 500);
            }else if(this.classList.contains('extend-accordion')){
                if(!$('.features-list__header.performances').hasClass('active')){
                    self.expandAcordionWithChart();
                }else{
                    self.scrollToPerformance();
                }
            }
			self.chartAjax(this.dataset.href);
		});
		$(document).on('click', '#themesModal .features-list__header.show-all', function(e) {
			self.chartAjax(this.dataset.href);
		});
        
        $(document).ready(function() {
            self.showPriceChart();
            if(document.getElementById('themesModal') && $(window).width() > 991){
                self.columnHeight();
            }
        });
	}
    expandAcordionWithChart(){
        let self = this;
        $('.features-list__header.performances').trigger('click')

        self.scrollToPerformance();
    }
    scrollToPerformance() {
        var distElementTop = $('.features-list__header.performances').offset().top - 90;

        $('html, body').animate({
            scrollTop: distElementTop
        }, 500);        
    }
    columnHeight() {
        let minHeight = document.querySelector('.theme-modal__top-row').clientHeight + 50;
        document.querySelector('.beforeFade').style.minHeight = minHeight+'px';
    }
    showPriceChart() {
        let self = this;
        if(typeof localStorage.getItem('showChart') !== 'object'){
            setTimeout(function() {
                $('.themes-list__price-bullet.show-chart').trigger('click');
            }, 2000);
            self.scrollToPerformance();
            localStorage.removeItem('showChart')
        }
    }
	chartAjax(url){
		let self = this;
		$.ajax({
            url: url,
            type: 'POST',
        }).success(function(res) {
        	let chart_wrapper_container = $('.theme-modal__chart-container'),
        		chart_wrapper = $('.theme-modal__chart'),
        		winWidth = $(window).width();

    		if(winWidth <= 767){
    			chart_wrapper_container.slideDown();
				chart_wrapper.addClass('active').html(res);
    			chart_wrapper.next('.theme-modal__nav-bullet').show({
				  	start: function () {
				    	$(this).css({
				    		display: "block"
						})
					}
    			});
    		}else{
				chart_wrapper.addClass('active').html(res);
				chart_wrapper_container.slideDown(500);
    		}
        });
	}
}